import React from "react"
import { getId } from "utils/custom.utils"
import classNames from "utils/classNames"

const VerticalTabs = ({
  className = undefined,
  items = undefined,
  selectedTab,
  onSelect,
  renderTab,
}) => {
  return (
    <table className={classNames("vt-vertical-tabs", className)}>
      <tbody>
        {items?.map((item, idx) => {
          return (
            <tr key={item?.id ?? idx}>
              <td
                onClick={e => onSelect(item)}
                className={classNames("vt-vertical-tab", {
                  "vt-vertical-tab-active": getId(selectedTab) === getId(item),
                })}
              >
                {renderTab(item)}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default VerticalTabs
